import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminCompaniesNew from './AdminCompaniesNew';

export default withRequiredAdmin(AdminCompaniesNew);
